function RecentlyViewedProducts() {
  var self = this;

  this.initialized = false;

  this.addToCart = function (variantId, quantity) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType: "json",
        data: {
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        },
        success: resolve,
        error: reject,
        timeout: reject,
      });
    });
  };

  function swymCallbackFn(swat) {
    // your API calls go here
    document.addEventListener("swym:collections-loaded", function () {
      swat.initializeActionButtons(".slides-wrapper");
    });
  }

  function roundHalf(num) {
    return Math.round(num * 2) / 2;
  }

  var clamp = function (num, min, max) {
    return Math.min(Math.max(num, min), max);
  };

  function calcStars(rating) {
    var clampedRating = clamp(rating, 0, 5);
    var fullStars = clamp(rating ? Math.floor(clampedRating) : 0, 0, 5);
    var halfStars = clamp(
      rating ? Math.ceil(roundHalf(clampedRating) - fullStars) : 0,
      0,
      5,
    );
    var emptyStars = clamp(rating ? 5 - fullStars - halfStars : 5, 0, 5);
    return {
      fullStars: fullStars,
      halfStars: halfStars,
      emptyStars: emptyStars,
    };
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(swymCallbackFn);

  var recentItems = localStorage.getItem("recently-viewed-products");
  recentItems = recentItems === null ? [] : JSON.parse(recentItems);

  var currentProduct = $('[data-section-type="recently-viewed-products"]');

  if (currentProduct.length) {
    var currentProductData = currentProduct.data("sectionSettings");

    // Remove current item from recents
    recentItems = recentItems.filter(function (item) {
      return item !== currentProductData.productHandle;
    });
  }

  if (recentItems.length === 0) {
    $("#shopify-section-recently-viewed-products").toggleClass("hidden", true);
  }

  // Fix Newest Page
  if (window.location.pathname == "/collections/newest") {
    jQuery("head").append(`<style>.modals, .shade-selector-modal__wrapper {
    display: none;
    }</style>`);
    jQuery("head").append(
      `<link rel="stylesheet" href="https://www.beautyaffairs.com.au/cdn/shop/t/310/assets/recently-viewed-products.css" type="text/css" />`,
    );
  }

  // Now fetch data from API
  Promise.allSettled(
    recentItems.map(function (item) {
      return new Promise(function (resolve, reject) {
        fetch("/products/".concat(item, ".js"))
          .then(function (resp) {
            return resp.json();
          })
          .then(function (res) {
            return res;
          })
          .then(resolve)
          .catch(reject);
      });
    }),
  )
    .then(function (promises) {
      return new Promise(function (resolve, reject) {
        var itemsApiData = promises
          .filter(function (promise) {
            return promise.status === "fulfilled";
          })
          .map(function (promise) {
            return promise.value;
          });
        var productReviewBody = itemsApiData.map(function (item) {
          return {
            productId: item.id.toString(),
            productType: item.type,
            productSKU: item.handle,
            productTitle: item.title,
          };
        });
        var reviewXHR = new XMLHttpRequest();

        reviewXHR.open("post", "https://stamped.io/api/widget/badges");

        reviewXHR.onreadystatechange = function () {
          if (
            reviewXHR.readyState === XMLHttpRequest.DONE &&
            reviewXHR.status === 200
          ) {
            resolve({
              itemData: itemsApiData,
              reviewData: reviewXHR.response,
            });
          }
        };

        reviewXHR.setRequestHeader(
          "Content-Type",
          "application/json;charset=UTF-8",
        );

        reviewXHR.send(
          JSON.stringify({
            productIds: productReviewBody,
            apiKey: window.StampedGlobalOptions.apiKey,
            storeUrl: window.StampedGlobalOptions.storeUrl,
          }),
        );
      });
    })
    .then(function (combinedData) {
      var reviews = JSON.parse(combinedData.reviewData);

      var recentsHtml = combinedData.itemData.map(function (item) {
        var reviewData = reviews.find(function (review) {
          return +review.productId === item.id;
        });
        var stars = calcStars(reviewData.rating);
        return '<div class="recently-viewed-product">\n            <button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_'
          .concat(item.id, '" data-swaction="addToWishlist" data-product-id="')
          .concat(item.id, '" data-variant-id="')
          .concat(item.variants[0].id, '" data-product-url="')
          .concat(window.location.origin)
          .concat(item.url, '"></button>\n    <a href="')
          .concat(
            item.url,
            '"><picture class="recently-viewed-product__image-wrapper">\n      <source src="',
          )
          .concat(item.featured_image, '" type="image/*">\n      <img src="')
          .concat(item.featured_image, '" alt="')
          .concat(
            item.title,
            '" class="product-image">\n    </picture></a>\n  \n    <div class="rating">',
          )
          .concat(
            Array.apply(null, Array(Math.floor(stars.fullStars)))
              .map(function () {
                return '<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>';
              })
              .join(""),
          )
          .concat(
            Array.apply(null, Array(Math.floor(stars.halfStars)))
              .map(function () {
                return '<i class="stamped-fa stamped-fa-star-half-o" aria-hidden="true"></i>';
              })
              .join(""),
          )
          .concat(
            Array.apply(null, Array(Math.floor(stars.emptyStars)))
              .map(function () {
                return '<i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
              })
              .join(""),
            '</div>\n    <a href="',
          )
          .concat(item.url, '"><h2 class="product-name">')
          .concat(
            item.title,
            '</h2></a>\n    <div class="prices">\n      <span class="',
          )
          .concat(
            item.compare_at_price > item.price
              ? "product-sale-price"
              : "product-single-price",
            '">',
          )
          .concat(
            Shopify.formatMoney(item.price, Shopify.money_format),
            "</span>\n      ",
          )
          .concat(
            item.compare_at_price > item.price
              ? '<span class="product-retail-price">'.concat(
                  Shopify.formatMoney(
                    item.compare_at_price,
                    Shopify.money_format,
                  ),
                  "</span>",
                )
              : "",
            '\n    </div>\n    <a class="recent-product-atc" href="javascript:void(0);" data-product-id="',
          )
          .concat(item.id, '" data-variant-id="')
          .concat(
            item.variants[0].id,
            '">',
            window.theme.labels.addToCart,
            "</a>\n  </div>",
          );
      });
      $(recentsHtml.join("")).appendTo(
        currentProduct.find(".products-slider .slides-wrapper"),
      );
      $(".recent-product-atc").on("click", function (e) {
        self.addToCart($(this).data("variantId"), 1);
      });
      setTimeout(function () {
        // Initialise swiper slider
        var swiper = new Swiper(".products-slider", {
          wrapperClass: "slides-wrapper",
          slideClass: "recently-viewed-product",
          slidesPerView: "auto",
          spaceBetween: 16,
        });
        swiper.on("afterInit", function () {
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        });
      }, 2000);
    });

  this.initialized = true;
  return self;
}

window.deferJS(
  function () {
    window.RecentlyViewedProducts = new RecentlyViewedProducts();
  },
  function () {
    return typeof window.StampedGlobalOptions !== "undefined";
  },
);
